@if (enabledCompanies) {
  <form [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>
        <mwp-text-translate text="Company" jsonKey="company" />
      </mat-label>
      <input type="text" matInput [formControlName]="nameForControl" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChanged($event)">
        @for (company of filteredCompanies$ | async; track company) {
          <mat-option [value]="company">
            {{company.companyName}}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
}